"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronRightSmallIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var ChevronRightSmallIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M12.2766478,10.2469389 C13.5206452,11.482755 14.5384615,12.4966441 14.5384615,12.5000253 C14.5384615,12.5121025 10.014535,17 10.0023614,17 C9.99552848,17 9.76720268,16.7786792 9.4949696,16.5081759 L9,16.0163519 L10.775991,14.2520285 L12.5519819,12.4877051 L10.7823337,10.7296832 L9.01268653,8.97166062 L9.50115989,8.4858308 C9.76982058,8.21862426 9.99530372,8 10.0022336,8 C10.0091636,8 11.0326503,9.01112292 12.2766478,10.2469389 Z" }))); };
exports.ChevronRightSmallIcon = ChevronRightSmallIcon;
